/** Shared class / grade labels for forms and attendance. */
export const CLASS_GROUP_OPTIONS = [
  'LKG', 'UKG', '1', '2', '3', '4', '5', '6', '7', '8', '9', '10', '11', '12'
] as const;
